// extracted by mini-css-extract-plugin
module.exports = {"customOverlay":"CenteredModal_customOverlay__1zJ-6","customModal":"CenteredModal_customModal__Tb2YQ"};